<template>
  <div>
    <div 
      v-for="item in msgListRes"
      :key="item.id"
      :class="['coupon-item','little_hand',{['coupon-item-isread']:item.isread||item.state}]" 
      @click="fnToNoticeDetails(item.messageId,item.member_messageId)">
      <p v-if="item.main_image" :style="'background-image:url('+item.main_image+');'"></p>
      <div class="coupon-info">
        <div class="coupon-info-border">
          <h3>{{item.title}}</h3>
          <span>{{item.desc}}</span>
        </div>
        <time>{{item.time}}</time>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data(){
    return{
      msgListRes:[]
    }
  },
  computed:{
    ...mapState(['user_id'])
  },
  watch:{
    user_id(val){
      this.getNoticeList()
    }
  },
  methods:{
    async getNoticeList() {
      const { data: res } = await this.$http.get(`/api/v2/notice/list/${this.user_id}/ZB`);
      // console.log('获取消息列表===',res);
      if (res.code !== "200") return false;
      this.msgListRes = res.data.map(item => {
          var time = item.publish_time || 0;
          item.time = this.$dayjs(time).month()+1+'月'+this.$dayjs(time).date()+'日';
          item.main_image = item.main_image?eval(item.main_image):'';
          item.main_image = item.main_image?item.main_image.map(img => this.$imgUrl + img):'';
          item.title=item.title;
          item.desc=item.content;
          item.messageId=item.notice_id
          item.member_messageId='';
          return item;
        });
    },
    fnToNoticeDetails(messageId,member_messageId){
      this.$router.push({
        path: `/my_message_details?id=${messageId}`,
      })
    }
  },
  mounted() {
    if(this.user_id){
      this.getNoticeList()
    }
  },
}
</script>

<style lang="less" scoped>
.coupon-item{
	background: #FFFFFF;
	box-shadow: 0 8px 20px 0 rgba(0,0,0,0.04), 0 0 30px 0 rgba(0,0,0,0.08);
	border-radius: 22px;
  overflow: hidden;
  margin:0 20px 16px;
}
.coupon-item-isread{
	opacity: 0.6;
}
.coupon-item p{
	width: 100%;
	height: 200px;
	// background: url('../../../../res/images/personalCenterBg.png') no-repeat center center;
	background-size: cover;
}
.coupon-info{
	padding: 16px 20px;
}
.coupon-info-border{
	padding-bottom: 8px;
	border-bottom: 1px solid #f8f8f8;
}
.coupon-info h3{
	font-family: 'PingFangSC-Semibold';
	font-size: 20px;
	color: #333333;
	line-height:28px;
	overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.coupon-info span{
	font-family: 'PingFangSC-Regular';
	font-size: 14px;
	color: #999999;
	line-height: 22px;
	overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.coupon-info time{
	font-family: 'PingFangSC-Regular';
	font-size: 14px;
	color: #999999;
	line-height: 22px;
	padding-top: 4px;
}
</style>